import client from "../client";

export interface CheckinBetResponse {
  is_reward?: boolean;
  message?: string;
  MessageTime?: null;
}

export default function API(): Promise<CheckinBetResponse> {
  return client
    .post(`gameinhouse/checkin/bet`)
    .then((response) => response.data);
}
